import classNames from "classnames";
import CustomModalHeader from "~/features/scanDmc/components/CustomModalHeader/CustomModalHeader";
import { Button } from "~/common/mui";
import Modal from "~/common/components/Modal";
import classes from "~/features/scanDmc/components/DMCIntroOverlay/DMCIntroOverlay.module.less";
import { CheckboxWithLabel } from "~/common/components/CheckboxWithLabel";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DmcIntroImage } from "~/features/scanDmc/components/DMCIntroOverlay/DmcIntroImage";
import { getOS } from "~/common/utils/browserChecks";
import { IconSize } from "~/common/components/icon/IconSize";
import { HOMEPAGE } from "~/utils/url/staticUrls";
import { BackLink } from "~/common/components/Link";
import { Alert } from "~/common/mui/Alert/Alert";

interface Props {
  onReturn: (dontShowAgain: boolean) => void;
  className?: string;
  dontShowAgain: boolean;
}

export const DMCIntroOverlay = (props: Props) => {
  const { t } = useTranslation();
  const [dontShowAgainChecked, setDontShowAgainChecked] = useState(props.dontShowAgain);

  const [isIOS] = useState(() => getOS() === "iOS");

  const closeCb = () => props.onReturn(dontShowAgainChecked);
  return (
    <Modal
      headerOverride={<CustomModalHeader />}
      onClose={() => undefined}
      footerChildren={
        <Button fullWidth={true} onClick={closeCb}>
          {t("page.scandmc.help.closeBtn")}
        </Button>
      }
      footerClassName={"scha__modal__footer--border"}
    >
      <div className={classNames(classes.root, props.className)}>
        <BackLink iconSize={IconSize.FONT_24} href={HOMEPAGE}>
          {t("navigation.home")}
        </BackLink>
        <div className={classes.section}>
          <div className={classes.pageTitle}>{t("page.scandmc.help.title")}</div>
          <p>{t("page.scandmc.help.instructions")}</p>
        </div>
        <div className={classes.section}>
          <p className={classes.imageTitle}>{t("page.scandmc.help.imageTitle")}</p>
          <div className={classes.imageContainer}>
            <DmcIntroImage />
          </div>
          {isIOS && <Alert severity={"info"}>{t("page.scandmc.iospermission")}</Alert>}
        </div>
        {!props.dontShowAgain && (
          <CheckboxWithLabel onCheck={setDontShowAgainChecked}>
            {t("page.scandmc.help.dontShowAgain")}
          </CheckboxWithLabel>
        )}
      </div>
    </Modal>
  );
};
